/* eslint-disable import/order */
import { expVal } from '@atlassian/jira-feature-experiments';
import { fg } from '@atlassian/jira-feature-gating';
import { getIssueViewResources } from '@jira/router-resources__issue-view/src/getIssueViewResources.tsx';
import { issueViewRelayResource } from '@jira/router-resources__issue-view/src/useIssueViewRelayRouteResource.tsx';
import { issueGiraDataResource } from '@jira/router-resources__issue-view/src/issueGiraDataResource.tsx';
import type { RouteResources } from '@atlassian/react-resource-router/src/common/types.tsx';

export const getIssueAppResources = (): RouteResources => {
	const issueAppResources: RouteResources = [];

	if (
		expVal('nin_glance_panel', 'isEnabled', false) ||
		fg('nin_issue_app_conditional_entrypoint')
	) {
		issueAppResources.push(issueViewRelayResource);

		if (!fg('remove-issueviewinteractivequery-m4')) {
			issueAppResources.push(issueGiraDataResource);
		}
	}

	if (fg('nin_glance_panel_technical_changes') || fg('nin_common_issue_view_resources')) {
		issueAppResources.push(...getIssueViewResources());
	}

	return issueAppResources;
};
